export default "__VITE_ASSET__Cd05lH9o__"